import { render, staticRenderFns } from "./guide-button.vue?vue&type=template&id=11ae3ce2&scoped=true&"
import script from "./guide-button.vue?vue&type=script&lang=ts&"
export * from "./guide-button.vue?vue&type=script&lang=ts&"
import style0 from "./guide-button.vue?vue&type=style&index=0&id=11ae3ce2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ae3ce2",
  null
  
)

export default component.exports